import { createAction, props } from '@ngrx/store';
import { Consultant, Raas, Permission, GoogleDirectory } from '../models/consultant.model';
import { Office } from '../models/office.model';
import { Client } from '../models/project';

export const setConsultantData = createAction('[Authentication Service] SetConsultantData', props<Consultant>());

export const setRaas = createAction('[Authentication Service] SetRaas',
  props<{ token: string; client: Client; googleDirectory: GoogleDirectory; raas: Raas, profilePicture: string }>()
);

export const setPermissions = createAction('[Authentication Service] SetPermissions', props<{ permissions: Permission[] }>());
export const setOffice = createAction('[OfficeSelector Component] SetOffice', props<Office>());

export const setProjects = createAction('[OfficeSelector Component] setProjects', props<{ projects: any}>());
